import React from 'react'
import { Chip } from '@mui/material'

const TYPE_CONFIG = {
  initial: { color: 'success', label: 'Entrada' },
  exit: { color: 'error', label: 'Saída' },
}

const InspectionTypeChip = ({ type }) => {
  const config = TYPE_CONFIG[type] || { color: 'default', label: type }
  return (
    <Chip
      size="small"
      variant="outlined"
      color={config.color}
      label={config.label}
    />
  )
}

export default InspectionTypeChip
